/**
 * Detect device type, browser, and OS from user agent
 */
import Hls from 'hls.js';

export interface DeviceInfo {
  device: 'mobile' | 'tablet' | 'desktop';
  browser: string;
  os: string;
}

export type AudioType = 'single-file' | 'hls-js' | 'hls-native';

export function getDeviceInfo(): DeviceInfo {
  const ua = navigator.userAgent;

  // Detect device type
  let device: 'mobile' | 'tablet' | 'desktop' = 'desktop';
  if (/iPad|Android(?!.*Mobile)/i.test(ua)) {
    device = 'tablet';
  } else if (
    /iPhone|iPod|Android.*Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)
  ) {
    device = 'mobile';
  }

  // Detect browser
  let browser = 'Unknown';
  if (/Edg\//i.test(ua)) {
    browser = 'Edge';
  } else if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) {
    browser = 'Chrome';
  } else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) {
    browser = 'Safari';
  } else if (/Firefox/i.test(ua)) {
    browser = 'Firefox';
  } else if (/MSIE|Trident/i.test(ua)) {
    browser = 'IE';
  }

  // Detect OS
  let os = 'Unknown';
  if (/iPhone|iPad|iPod/i.test(ua)) {
    os = 'iOS';
  } else if (/Android/i.test(ua)) {
    os = 'Android';
  } else if (/Mac OS X/i.test(ua)) {
    os = 'macOS';
  } else if (/Windows/i.test(ua)) {
    os = 'Windows';
  } else if (/Linux/i.test(ua)) {
    os = 'Linux';
  }

  return { device, browser, os };
}

/**
 * Determine the HLS implementation type based on browser support
 */
export function getHlsType(): 'hls-js' | 'hls-native' {
  return Hls.isSupported() ? 'hls-js' : 'hls-native';
}

export function formatDeviceInfo(
  info: DeviceInfo,
  audioType: AudioType
): string {
  return `Device: ${info.device}, Browser: ${info.browser}, OS: ${info.os}, Audio: ${audioType}`;
}
